import type { ReportAccess } from '../types/reportAccess'
import { fetchApi } from './api'

/**
 * The per-report access explanation.
 *
 * Shares the registry's route prefix on the server (a separate controller, one
 * sub-route), gated on Lighthouse.Admin like every ReportBuilder reader under
 * Controllers/System. Goes through the shared `fetchApi`, so a 403 arrives as an
 * ApiError with its status and the drawer can render it as restricted rather than
 * broken.
 */
export function getReportAccess(reportId: string): Promise<ReportAccess> {
  return fetchApi<ReportAccess>(`/api/observatory/registry/${encodeURIComponent(reportId)}/access`)
}
